import React, { useState } from "react";

const TeamMembersSelect = ({ members }) => {
  const [selectedMembers, setSelectedMembers] = useState(
    members.map((m) => m.id) // default select all
  );

  const allSelected = selectedMembers.length === members.length;

  const toggleAll = () => {
    if (allSelected) {
      setSelectedMembers([]);
    } else {
      setSelectedMembers(members.map((m) => m.id));
    }
  };

  const toggleMember = (id) => {
    setSelectedMembers((prev) =>
      prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]
    );
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-xl font-semibold">Team members required</h2>
        <p className="text-gray-500 text-sm">
          Choose which team members will perform this service
        </p>
      </div>

      {/* Select All */}
      <label className="flex items-center gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={allSelected}
          onChange={toggleAll}
          className="h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
        />
        <span className="font-medium">All team members</span>
        <span className="text-xs bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full">
          {members.length}
        </span>
      </label>

      {/* Divider */}
      <hr />

      {/* Member list */}
      <div className="space-y-4">
        {members.map((member) => {
          const selected = selectedMembers.includes(member.id);

          return (
            <div key={member.id} className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={selected}
                onChange={() => toggleMember(member.id)}
                className="h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
              />

              {/* Avatar initials */}
              <div
                className={`flex items-center justify-center w-10 h-10 rounded-full border-2 text-sm font-bold ${
                  selected ? "border-purple-400" : "border-gray-200"
                }`}
              >
                {member.initials}
              </div>

              {/* Info */}
              <div className="flex flex-col">
                <span className="font-medium">{member.name}</span>
                <span className="text-sm text-gray-500">{member.role}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TeamMembersSelect;
